import { format } from 'date-fns';

export const getFormattedDate = (value: Date) => {
  return format(value, 'dd/MM/yyyy');
};
